/* eslint-disable react/no-array-index-key */
import { createContext, h, render } from 'preact'
import { useEffect, useState } from 'preact/hooks'
import ContentBlocks from '../ContentBlocks/ContentBlocks'

const WidgetZoneContext = createContext({
	widgetZones: [],
})

function renderContentBlocks(widgetZones, contentBlocks, renderTitles) {
	if (!contentBlocks || !widgetZones.length) return []

	// Set object to hold widget zones
	const wzs = {}

	// For every given widgetZone, check if there is a
	// corresponding widgetZone slot in the DOM
	Array.from(widgetZones).forEach(wz => {
		const zone = wz.getAttribute('data-widget-zone')

		// Add the widget zone to the object
		if (zone) wzs[zone] = wz
	})

	// For every content block given,
	// check if there is a corresponding widget zone
	contentBlocks.forEach((block, i) => {
		// Get the widget zone from the set object
		const widgetZone = wzs[block.widgetZone]

		if (widgetZone) {
			// Create new slot that will hold the JSX
			// The slot element will not take up space or cost calculation time
			const t = document.createElement('slot')

			// Render JSX into element
			render(<ContentBlocks key={i} data={block} renderTitle={renderTitles} />, t)

			// Append node to corresponding widget zone slot in DOM
			widgetZone.appendChild(t)
		}
	})
}

export function WidgetZoneProvider({ children, contentBlocks, renderTitles }) {
	const [widgetZones, setWidgetZones] = useState([])

	useEffect(() => {
		setTimeout(() => {
			const zones = document.querySelectorAll('slot[data-widget-zone]')

			if (zones) setWidgetZones(zones)
		}, 1)
	}, [])

	if (contentBlocks) renderContentBlocks(widgetZones, contentBlocks, renderTitles)

	return children
}

export default WidgetZoneContext
